import * as React from 'react'

import { action, makeObservable } from 'mobx'
import { observer } from 'mobx-react'
import { classList } from 'react-classlist-helper'

import DeliveryDetailsStore from '~/client/src/shared/components/DeliveryDetails/DeliveryDetails.store'
import Dimmer from '~/client/src/shared/components/Dimmer'
import FieldIds from '~/client/src/shared/enums/DeliveryFieldIds'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import { notifyOverlayOpen } from '~/client/src/shared/utils/overlayNotifier'

import TimePicker from '../DeliverySelectDateModal/components/TimePicker'

// localization: translated

interface IProps {
  shown: boolean
  onHide: () => void

  initStartDate?: number | Date
  initEndDate?: number | Date

  deliveryDetailsStore: DeliveryDetailsStore
}

@observer
export default class DeliverySelectTimeModal extends React.Component<IProps> {
  private closeOverlay: (() => void) | null = null

  public constructor(props: IProps) {
    super(props)
    makeObservable(this)
  }

  public componentDidMount() {
    if (this.props.shown) {
      this.closeOverlay = notifyOverlayOpen()
    }
  }

  public componentDidUpdate(prevProps: IProps) {
    if (!prevProps.shown && this.props.shown) {
      this.closeOverlay = notifyOverlayOpen()
    } else if (prevProps.shown && !this.props.shown) {
      this.closeOverlay?.()
      this.closeOverlay = null
    }
  }

  public componentWillUnmount() {
    this.closeOverlay?.()
  }

  public render() {
    const { selectedTimeControl, selectedTimes } =
      this.props.deliveryDetailsStore
    const { onHide, shown } = this.props

    const { startTime, endTime } = selectedTimes || {}

    const isStartTime = selectedTimeControl === FieldIds.START_TIME
    const defaultTime = isStartTime ? startTime : endTime
    const title = isStartTime
      ? Localization.translator.startTime
      : Localization.translator.endTime

    return (
      <>
        <Dimmer shown={shown} onClick={onHide} />
        <div
          className={classList({
            'tw:hidden tw:bottom-0 tw:opacity-0 tw:transition-all tw:duration-[400ms] tw:absolute tw:left-0 tw:right-0 tw:z-[100] tw:bg-background tw:rounded-t-[8px]': true,
            'tw:!block tw:opacity-100': shown,
          })}
        >
          {shown && (
            <TimePicker
              title={title}
              defaultTime={defaultTime}
              onApply={this.onApply}
              onHide={this.props.onHide}
            />
          )}
        </div>
      </>
    )
  }

  @action.bound
  private onApply(timeString: string) {
    const { selectedTimeControl, onFieldValueChange } =
      this.props.deliveryDetailsStore

    onFieldValueChange(selectedTimeControl, timeString)
    this.props.onHide()
  }
}
